// Static content for Best Day Ever Productions
// Sourced from book.weddingvideo.co.uk, weddingvideoessexreviews.co.uk and weddingvideo.co.uk

export const BRAND = {
  name: "Best Day Ever Productions",
  parent: "Wedding Video Essex",
  tagline: "Photos & Films",
  logoUrl: "https://customer-assets.emergentagent.com/job_bafa3ee3-5078-49ba-b2a5-21815bd2c557/artifacts/xrxsniik_2.png",
  established: 2015,
  base: "Wickford, Essex",
  baseAddress: "Unit 6 Hodgson Court, Hodgson Way, Wickford, Essex, SS11 8XR",
  email: "alex@weddingvideo.co.uk",
  phone: "+44 (0)1268 000000",
  instagram: "@weddingphotographeressex",
  address: "Unit 6 Hodgson Court, Hodgson Way, Wickford, Essex, SS11 8XR",
  bookingLink: "https://book.weddingvideo.co.uk/",
};

export const HERO_IMAGES = [
  { src: "https://customer-assets.emergentagent.com/job_8d44df25-0f67-4d0d-b916-c24ae1fa8d16/artifacts/3xdtp1cg_Preview-45.jpg", caption: "Katie & Matt said yes" },
  { src: "https://customer-assets.emergentagent.com/job_wve-wedding-showcase/artifacts/4tj3d52l_Helen%20%26%20Daniel%2014-07-25%20%20009.jpg", caption: "Helen & Daniel" },
  { src: "https://customer-assets.emergentagent.com/job_wve-wedding-showcase/artifacts/aiky4ekf_Paige__Richard_070724__625.jpg", caption: "Paige & Richard" },
  { src: "https://customer-assets.emergentagent.com/job_8d44df25-0f67-4d0d-b916-c24ae1fa8d16/artifacts/lgsxk5pq_Bonnie__Josh_SP_.jpg", caption: "Bonnie & Josh" },
];

export const GALLERY_IMAGES = [
  "https://customer-assets.emergentagent.com/job_8d44df25-0f67-4d0d-b916-c24ae1fa8d16/artifacts/3xdtp1cg_Preview-45.jpg",
  "https://customer-assets.emergentagent.com/job_wve-wedding-showcase/artifacts/aiky4ekf_Paige__Richard_070724__625.jpg",
  "https://customer-assets.emergentagent.com/job_wve-wedding-showcase/artifacts/4tj3d52l_Helen%20%26%20Daniel%2014-07-25%20%20009.jpg",
  "https://customer-assets.emergentagent.com/job_8d44df25-0f67-4d0d-b916-c24ae1fa8d16/artifacts/lgsxk5pq_Bonnie__Josh_SP_.jpg",
  "https://img.youtube.com/vi/RGPac3bPqmg/maxresdefault.jpg",
  "https://img.youtube.com/vi/yiIvnO9d1HU/maxresdefault.jpg",
  "https://img.youtube.com/vi/QcmgME010MU/maxresdefault.jpg",
  "https://img.youtube.com/vi/BVYGZ1jG8G0/maxresdefault.jpg",
  "https://img.youtube.com/vi/1DXk4bMe3WM/maxresdefault.jpg",
  "https://img.youtube.com/vi/KTLcIqddWSE/maxresdefault.jpg",
  "https://img.youtube.com/vi/tSAyeoBfnOk/maxresdefault.jpg",
  "https://img.youtube.com/vi/IwzzvUeYHxw/maxresdefault.jpg",
];

export const ALEX = {
  name: "Alex Moore",
  role: "Founder & Head of Memory Making",
  imageUrl: "https://customer-assets.emergentagent.com/job_8d44df25-0f67-4d0d-b916-c24ae1fa8d16/artifacts/ifu7svtq_IMG_1066.jpeg",
  bio: [
    "Best Day Ever is the brand we use to capture the weddings that don't fit the rule book. Same team behind Wedding Video Essex (the award-winners), same camera kit, same dog-loving humans, just with a freer hand and a much louder Spotify playlist.",
    "From your very first DM to the moment you press play on your final film, you'll deal with one person who genuinely cares about getting your day right. No call centres. No being passed around. Just a friend with two cameras and a soft spot for first dances.",
    "Alex founded Wedding Video Essex in 2015 because he believes every couple deserves a film that makes them feel it all again. 1000+ couples later, he still gets emotional watching the edits back. Yes, really.",
  ],
};

export const STATS = [
  { value: "1000+", label: "Happy couples" },
  { value: "397", label: "Five-star reviews" },
  { value: "12+", label: "Years filming weddings" },
  { value: "8×", label: "Award Winners" },
];

export const AWARDS = [
  { name: "Essex Wedding Awards Winner 2026", url: "https://customer-assets.emergentagent.com/job_wve-wedding-showcase/artifacts/t490eo40_essex-wedding-awards-winner-logo-2026.png" },
  { name: "Hitched Wedding Awards 2026", url: "https://customer-assets.emergentagent.com/job_wve-wedding-showcase/artifacts/6c9sworo_badge-weddingawards_en_GB_edited.png" },
  { name: "Bridebook Platinum 2026", url: "https://image.bridebook.com/badge/platinum-2026-uk@v1.png" },
];

export const VENUES = [
  "Gaynes Park", "Crondon Park", "Greenwoods", "Friern Manor", "Hatfield Place",
  "Channels Retreat", "The Warren Estate", "Parklands Quendon Hall", "Fennes",
  "Vaulty Manor", "Hutton Hall", "Wivenhoe House", "Apton Hall", "Braxted Park",
  "High House Weddings", "Maidens Barn", "Mulberry House", "Ingrebourne Links",
  "East Mersea Hall", "Downham Hall", "Little Channels", "Prested Hall",
  "The Heron Country Club", "That Amazing Place", "Warley Park", "Stock Brook Manor",
  "Swynford Manor", "St Osyth Priory",
];

export const PACKAGES = [
  {
    id: "photos",
    badge: "Just Photos",
    name: "The Photos",
    price: "£1,500",
    monthly: "from £125/mo",
    popular: false,
    tagline: "Just photos. Just gorgeous.",
    bullets: [
      "One photographer for up to 8 hours",
      "Online gallery with 500+ professionally edited photos",
      "30–40 sneak peek photos within one week",
      "Full digital delivery, yours forever",
    ],
  },
  {
    id: "film",
    badge: "Just Film",
    name: "The Film",
    price: "£1,500",
    monthly: "from £125/mo",
    popular: false,
    tagline: "A short, punchy, rewatch-100-times kind of film.",
    bullets: [
      "One videographer for up to 8 hours",
      "10–15 minute highlight film",
      "Your full ceremony & speeches, uncut from a fixed wide camera",
      "Sneak peek within 72 hours",
      "Full digital delivery, yours forever",
    ],
  },
  {
    id: "shebang",
    badge: "Most Popular",
    name: "The BEST of Both!",
    price: "£2,000",
    monthly: "from £166/mo",
    popular: true,
    tagline: "Photos AND film. Zero FOMO.",
    bullets: [
      "One videographer + one photographer",
      "Up to 8 hours coverage",
      "10–15 minute highlight film",
      "Your full ceremony & speeches, uncut from a fixed wide camera",
      "300–500 professionally edited photos",
      "Sneak peeks within 72 hours",
    ],
  },
];

export const FILMS = [
  { id: "RGPac3bPqmg", title: "Katie & Matt", venue: "High House" },
  { id: "yiIvnO9d1HU", title: "Helen & Daniel", venue: "Parklands Quendon Hall" },
  { id: "QcmgME010MU", title: "Paige & Richard", venue: "The Warren Estate" },
  { id: "BVYGZ1jG8G0", title: "Bonnie & Josh", venue: "The Roslin Hotel" },
  { id: "1DXk4bMe3WM", title: "Leah & Josh", venue: "Gaynes Park" },
  { id: "KTLcIqddWSE", title: "Emma & Mark", venue: "Gaynes Park" },
];

export const GUESTBOOK = {
  name: "The Video Guestbook",
  badge: "Add-on of dreams",
  priceFrom: "From £195",
  exampleVideoId: "crM-ixYOXos",
  headline: "Your guests. On camera.",
  accent: "Saying things they'd never write in a card.",
  blurb:
    "Forget paper guestbooks nobody reads and the photo booth that ate £600 of your budget. Our slimline video booth tucks into a corner of your venue all day, your guests tap record, and you end up with a film of every drunk uncle, sobbing best mate and three-year-old saying something completely cursed.",
  ps:
    "It's like a confession booth that won't snitch, but for love. Most-watched thing on your hard drive in 10 years, guaranteed.",
  highlights: [
    "Designed & built in-house by the WVE team",
    "Slimline booth that blends in (no big ugly rig)",
    "Unlimited video recordings",
    "A human on-site to keep guests recording",
    "Edited together into one ridiculous, beautiful film",
    "Add-on to any package, or book as a standalone",
  ],
  images: [
    "https://static.wixstatic.com/media/1fe187_c9cb79c6910749c2b813723b7d836f4d~mv2.jpg/v1/fill/w_620,h_930,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Video%20Pods%2006-08-25%20%20004.jpg",
    "https://static.wixstatic.com/media/1fe187_d85013f812924bf797f54bc231177fa7~mv2.png/v1/fit/w_640,h_854,q_85,enc_avif,quality_auto/1fe187_d85013f812924bf797f54bc231177fa7~mv2.png",
    "https://static.wixstatic.com/media/1fe187_15f6b181d344415694d907d0bcd21537~mv2.png/v1/fit/w_960,h_720,q_85,enc_avif,quality_auto/1fe187_15f6b181d344415694d907d0bcd21537~mv2.png",
    "https://static.wixstatic.com/media/1fe187_8be7e8eb330e491ab9b2d76386413784~mv2.png/v1/fit/w_640,h_853,q_85,enc_avif,quality_auto/1fe187_8be7e8eb330e491ab9b2d76386413784~mv2.png",
    "https://static.wixstatic.com/media/1fe187_57e82518160248079dfd330a40cea64c~mv2.png/v1/fit/w_960,h_720,q_85,enc_avif,quality_auto/1fe187_57e82518160248079dfd330a40cea64c~mv2.png",
    "https://static.wixstatic.com/media/1fe187_1ac6faf8a40445818785dd9d186a8a6b~mv2.png/v1/fit/w_960,h_720,q_85,enc_avif,quality_auto/1fe187_1ac6faf8a40445818785dd9d186a8a6b~mv2.png",
  ],
};

export const REVIEWS = [
  {
    quote: "Excellent company and genuinely lovely guys. They know what they are doing and do it well. Couldn't fault a single thing about how they captured our wedding day.",
    name: "Chris",
    source: "Hitched",
    date: "2026",
  },
  {
    quote: "We hired Alex and his team last year for our wedding and I couldn't be more happy that we did. The service was perfect from start to finish. Complete professionalism but with a personal touch.",
    name: "Stephen",
    source: "Hitched",
    date: "15/05/2026",
  },
  {
    quote: "I would give the team more than 5 stars here if I could. I 1000% recommend. Having the team there was more like 3 additional friends as wedding guests.",
    name: "Michelle & Ken",
    source: "Bridebook",
    date: "01/05/2026",
  },
  {
    quote: "We honestly couldn't have asked for a better team to capture our special day. From start to finish, they were absolutely incredible. Professional, friendly, and so easy to work with.",
    name: "Matthew",
    source: "Hitched",
    date: "16/04/2026",
  },
  {
    quote: "We received sneak peeks within a few days after the wedding. We opted for photo and video, and the team were unreal on the day.",
    name: "Paige",
    source: "Hitched",
    date: "30/03/2026",
  },
  {
    quote: "Me and my partner are both really camera awkward and it honestly felt like just having more friends at the wedding than it did a photographer and videographer.",
    name: "Michelle",
    source: "Hitched",
    date: "24/03/2026",
  },
  {
    quote: "Alex and his team filmed our wedding in September 2025 and all I can say is wow! Professional, friendly and nothing is too much trouble. A video wasn't a priority but now it's the best decision we made!",
    name: "Vicki Cambridge",
    source: "Google",
    date: "2025",
  },
  {
    quote: "Honestly, ridiculous. We've watched our film about forty times. My nan cried. Our dog cried (probably).",
    name: "Em & J",
    source: "Google",
    date: "2026",
  },
];

export const FAQS = [
  {
    q: "We're not sure we need a videographer…",
    a: "We hear this a lot, and we get it. Then we ask people what their biggest wedding regret is. The answer, more often than not? Not booking a videographer. Your flowers will wilt, your cake will be eaten. Your film? That's the thing that lasts forever.",
  },
  {
    q: "How much does it cost?",
    a: "Packages start at £1,500 for photo-only and go up to £2,000 for the full photo + film combo. Every package includes full digital delivery, zero travel charges inside Essex, and interest-free monthly payments via Klarna.",
  },
  {
    q: "Will you be in the way? We want it to feel natural.",
    a: "Absolute zero cringe, promise. We blend in, move quietly, and let your day unfold. Couples often forget we're there until they spot us at the buffet. Posed couple portraits and family group shots are kept short, fun and painless.",
  },
  {
    q: "What style of film and photos do you shoot?",
    a: "Cinematic, story-led films that feel like the day actually felt. Photography sits between relaxed documentary and natural portraiture. Real moments, real emotion, plus a handful of beautiful portraits you'll want on the wall.",
  },
  {
    q: "How long until we get our films and photos?",
    a: "Sneak peeks land within 72 hours of the big day. Your full photo and film collection is delivered in around 12–15 weeks via our private viewing platform. Watch, download, share. Forever yours.",
  },
  {
    q: "Where in Essex (and beyond) do you cover?",
    a: "Based in Wickford and covering the whole of Essex: Chelmsford, Colchester, Southend, Brentwood, Romford, Basildon and everywhere in between. We also film across London, Kent, Hertfordshire and Suffolk.",
  },
  {
    q: "Can we get the raw footage?",
    a: "Short answer: no, and you really don't want it. Long answer: a 12-hour wedding day produces hundreds of GB of unedited clips that don't make sense without the edit. The film you'll watch back is the magic.",
  },
  {
    q: "How do we book?",
    a: "Hit the contact form, drop us your date and venue, and we'll get back within 24 hours. We do a free consult call, send a personalised quote, and a small deposit secures your date. Klarna available on all packages.",
  },
  {
    q: "What if it rains? (It's England.)",
    a: "Some of our favourite films and photos have come from soggy days. We adapt, we improvise, we have a coat. The weather never beats us.",
  },
];

export const HOW_IT_WORKS = [
  {
    step: "01",
    title: "Slide into our DMs",
    body: "Send your date, venue and a few words. Reply within 24 hours, guaranteed.",
  },
  {
    step: "02",
    title: "Free vibe-check call",
    body: "A 20-minute chat about your day, your vision, and how we make it a film you'll actually rewatch.",
  },
  {
    step: "03",
    title: "Lock the date",
    body: "Personalised quote, small deposit, and your wedding is officially in the diary. Klarna available.",
  },
];

export const AREAS = [
  { post: "CM1–CM3", name: "Chelmsford", note: "0 mins, base location" },
  { post: "CO1–CO7", name: "Colchester", note: "40 mins from Wickford" },
  { post: "SS0–SS9", name: "Southend-on-Sea", note: "25 mins from Wickford" },
  { post: "CM13–CM15", name: "Brentwood", note: "20 mins from Wickford" },
  { post: "RM1–RM7", name: "Romford", note: "30 mins from Wickford" },
  { post: "SS13–SS16", name: "Basildon", note: "15 mins from Wickford" },
];
